import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "adash" }
const _hoisted_2 = {
  class: "adash__kpis",
  "data-tour": "admin-dash-kpi"
}
const _hoisted_3 = { class: "adash__kpi-label" }
const _hoisted_4 = { class: "adash__kpi-value" }
const _hoisted_5 = {
  key: 0,
  class: "sui-card sui-card--flush adash__tax",
  "data-tour": "admin-dash-tax"
}
const _hoisted_6 = { class: "sui-card__head" }
const _hoisted_7 = { class: "sui-card__title" }
const _hoisted_8 = { class: "sui-table-wrap" }
const _hoisted_9 = { class: "sui-table" }
const _hoisted_10 = { class: "sui-table__strong" }
const _hoisted_11 = { class: "sui-table__sub" }
const _hoisted_12 = {
  key: 0,
  class: "sui-table__sub"
}
const _hoisted_13 = { class: "adash__email" }
const _hoisted_14 = { class: "is-num sui-table__strong" }
const _hoisted_15 = { class: "sui-table__sub" }
const _hoisted_16 = { class: "is-center" }
const _hoisted_17 = { class: "adash__cols" }
const _hoisted_18 = {
  class: "sui-card sui-card--flush adash__requests",
  "data-tour": "admin-dash-queue"
}
const _hoisted_19 = { class: "sui-card__head" }
const _hoisted_20 = { class: "sui-card__title" }
const _hoisted_21 = {
  key: 0,
  class: "sui-table-wrap"
}
const _hoisted_22 = { class: "sui-table" }
const _hoisted_23 = { class: "sui-prod" }
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = {
  key: 1,
  class: "adash__noimg"
}
const _hoisted_26 = { class: "sui-prod__name" }
const _hoisted_27 = { class: "sui-table__sub" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "is-num sui-table__strong" }
const _hoisted_30 = { class: "sui-table__sub" }
const _hoisted_31 = {
  key: 0,
  class: "adash__note"
}
const _hoisted_32 = { class: "is-center" }
const _hoisted_33 = {
  key: 1,
  class: "sui-empty"
}
const _hoisted_34 = { class: "adash__side" }
const _hoisted_35 = {
  class: "sui-card adash__todo",
  "data-tour": "admin-dash-links"
}
const _hoisted_36 = { class: "sui-card__head" }
const _hoisted_37 = { class: "sui-card__title" }
const _hoisted_38 = { class: "sui-card__body" }
const _hoisted_39 = { class: "adash__todo-grid" }
const _hoisted_40 = { class: "adash__task-label" }
const _hoisted_41 = { class: "sui-card adash__guide" }
const _hoisted_42 = { class: "sui-card__body" }
const _hoisted_43 = { class: "adash__steps" }

import { computed, onMounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchAdminOpsKpis, type AdminOpsKpis } from '@/api/admin'
import { useAdminProducts } from '@/composables/useAdminProducts'
import { formatWon } from '@/constants/sellerData'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboardPage',
  setup(__props) {

const { products, counts, loading, load } = useAdminProducts()

const ops = ref<AdminOpsKpis>({
  pendingPayments: 0,
  payNotified: 0,
  claimPending: 0,
  unshipped: 0,
  taxInvoicePending: 0,
  taxInvoiceQueue: [],
})

onMounted(async () => {
  await load()
  try {
    ops.value = await fetchAdminOpsKpis()
  } catch {
    ops.value = {
      pendingPayments: 0,
      payNotified: 0,
      claimPending: 0,
      unshipped: 0,
      taxInvoicePending: 0,
      taxInvoiceQueue: [],
    }
  }
})

const requested = computed(() => products.value.filter((product) => product.status === 'REQUESTED'))

const kpis = computed(() => [
  {
    label: '입금 미진행',
    value: ops.value.pendingPayments,
    unit: '건',
    icon: 'mdi-cash-clock',
    tone: 'amber',
    to: '/admin/orders?section=unnotified',
    alert: ops.value.pendingPayments > 0,
  },
  {
    label: '입금 알림',
    value: ops.value.payNotified,
    unit: '건',
    icon: 'mdi-bell-ring-outline',
    tone: 'amber',
    to: '/admin/orders?section=notified',
    alert: ops.value.payNotified > 0,
  },
  {
    label: '클레임 대기',
    value: ops.value.claimPending,
    unit: '건',
    icon: 'mdi-package-variant-remove',
    tone: 'red',
    to: '/admin/orders?work=claim',
    alert: ops.value.claimPending > 0,
  },
  {
    label: '미출고',
    value: ops.value.unshipped,
    unit: '건',
    icon: 'mdi-truck-delivery-outline',
    tone: 'green',
    to: '/admin/orders?section=shipping',
    alert: ops.value.unshipped > 0,
  },
  {
    label: '세금계산서',
    value: ops.value.taxInvoicePending,
    unit: '건',
    icon: 'mdi-file-document-outline',
    tone: 'violet',
    to: '/admin/orders?tax=1',
    alert: ops.value.taxInvoicePending > 0,
  },
  {
    label: '검수요청',
    value: counts.value.REQUESTED ?? 0,
    unit: '건',
    icon: 'mdi-clipboard-alert-outline',
    tone: 'violet',
    to: '/admin/products?status=REQUESTED',
    alert: (counts.value.REQUESTED ?? 0) > 0,
  },
])

const tasks = computed(() => [
  {
    label: '입금 미진행',
    count: ops.value.pendingPayments,
    to: '/admin/orders?section=unnotified',
  },
  {
    label: '입금 알림',
    count: ops.value.payNotified,
    to: '/admin/orders?section=notified',
  },
  {
    label: '상품 검수',
    count: counts.value.REQUESTED ?? 0,
    to: '/admin/products?status=REQUESTED',
  },
  {
    label: '클레임 처리',
    count: ops.value.claimPending,
    to: '/admin/orders?work=claim',
  },
  {
    label: '미출고 확인',
    count: ops.value.unshipped,
    to: '/admin/orders?section=shipping',
  },
  {
    label: '세금계산서',
    count: ops.value.taxInvoicePending,
    to: '/admin/orders?tax=1',
  },
])

const taskTotal = computed(() => tasks.value.reduce((sum, task) => sum + task.count, 0))

const steps = [
  { title: '1. 요청 내용 확인', desc: '판매업체가 보낸 상품명 · 가격 · 요청 메모를 먼저 봅니다.' },
  { title: '2. 내용 보강', desc: '이미지, 상세 페이지, 스펙, 옵션, 해시태그를 관리자가 채웁니다.' },
  { title: '3. 미리보기', desc: '구매 기관에게 보일 화면을 확인합니다.' },
  { title: '4. 승인 또는 반려', desc: '승인하면 바로 몰에 올라가고, 반려하면 사유가 판매업체에 전달됩니다.' },
]

function formatDate(value: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${date.getMonth() + 1}.${date.getDate()} ${String(date.getHours()).padStart(2, '0')}:${String(
    date.getMinutes(),
  ).padStart(2, '0')}`
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpis.value, (card) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: card.label,
          to: card.to,
          class: _normalizeClass(["sui-card adash__kpi", { 'is-alert': card.alert }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["adash__kpi-icon", `adash__kpi-icon--${card.tone}`])
            }, [
              _createVNode(AppIcon, {
                icon: card.icon,
                size: 20
              }, null, 8, ["icon"])
            ], 2),
            _createElementVNode("span", _hoisted_3, _toDisplayString(card.label), 1),
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(card.value), 1),
              _createElementVNode("em", null, _toDisplayString(card.unit), 1)
            ])
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ]),
    (ops.value.taxInvoicePending > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, [
              _cache[0] || (_cache[0] = _createTextVNode(" 세금계산서 발행 대기 ", -1)),
              _createElementVNode("em", null, _toDisplayString(ops.value.taxInvoicePending) + "건", 1)
            ]),
            _createVNode(_component_router_link, {
              to: "/admin/orders?tax=1",
              class: "sui-card__link"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createTextVNode(" 주문·입금에서 보기 ", -1)),
                _createVNode(AppIcon, {
                  icon: "mdi-chevron-right",
                  size: 15
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "주문"),
                  _createElementVNode("th", null, "기관 · 상호"),
                  _createElementVNode("th", null, "수신 이메일"),
                  _createElementVNode("th", { class: "is-num" }, "금액"),
                  _createElementVNode("th", null, "요청"),
                  _createElementVNode("th", { class: "is-center" }, "처리")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ops.value.taxInvoiceQueue, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.code
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(row.code), 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(formatDate(row.orderedAt)), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(row.orgName || '—'), 1),
                      (row.bizName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.bizName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(row.taxEmail || '—'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatWon)(row.totalAmount)) + "원", 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(row.taxAt)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createVNode(_component_router_link, {
                        to: { path: '/admin/orders', query: { tax: '1', keyword: row.code } },
                        class: "sui-btn sui-btn--sm sui-btn--primary"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" 확인하기 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("section", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("h2", _hoisted_20, [
            _cache[4] || (_cache[4] = _createTextVNode(" 검수요청 ", -1)),
            _createElementVNode("em", null, _toDisplayString(requested.value.length) + "건", 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/admin/products?status=REQUESTED",
            class: "sui-card__link"
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createTextVNode(" 전체 보기 ", -1)),
              _createVNode(AppIcon, {
                icon: "mdi-chevron-right",
                size: 15
              })
            ]),
            _: 1
          })
        ]),
        (requested.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("table", _hoisted_22, [
                _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "상품"),
                    _createElementVNode("th", null, "판매업체"),
                    _createElementVNode("th", { class: "is-num" }, "판매가"),
                    _createElementVNode("th", null, "요청"),
                    _createElementVNode("th", { class: "is-center" }, "처리")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requested.value.slice(0, 8), (product) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: product.code
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_23, [
                          (product.thumbnail)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "sui-prod__img",
                                src: product.thumbnail,
                                alt: product.name,
                                loading: "lazy"
                              }, null, 8, _hoisted_24))
                            : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                _createVNode(AppIcon, {
                                  icon: "mdi-image-off-outline",
                                  size: 16
                                })
                              ])),
                          _createElementVNode("span", null, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(product.name), 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(product.code) + " · " + _toDisplayString(product.category), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (product.storeName)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "adash__store-link",
                              to: {
                      path: '/admin/products',
                      query: { status: 'REQUESTED', keyword: product.storeName },
                    }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(product.storeName), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatWon)(product.price)) + "원", 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(formatDate(product.requestedAt)), 1),
                        (product.requestNote)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(product.requestNote), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        _createVNode(_component_router_link, {
                          to: `/admin/products/${product.code}`,
                          class: "sui-btn sui-btn--sm sui-btn--primary"
                        }, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" 검수하기 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(AppIcon, {
                icon: "mdi-check-circle-outline",
                size: 30
              }),
              _createElementVNode("p", null, _toDisplayString(_unref(loading) ? '불러오는 중입니다…' : '검수를 기다리는 상품이 없습니다.'), 1)
            ]))
      ]),
      _createElementVNode("aside", _hoisted_34, [
        _createElementVNode("section", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h2", _hoisted_37, [
              _cache[8] || (_cache[8] = _createTextVNode(" 바로 처리할 일 ", -1)),
              _createElementVNode("em", null, _toDisplayString(taskTotal.value) + "건", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: task.label,
                  to: task.to,
                  class: "adash__task"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["adash__task-count", { 'is-zero': !task.count }])
                    }, _toDisplayString(task.count), 3),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(task.label), 1),
                    _createVNode(AppIcon, {
                      class: "adash__task-arrow",
                      icon: "mdi-chevron-right",
                      size: 16
                    })
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "sui-hint adash__todo-note" }, "입금 확인 → 상품관리(검수) → 클레임·환불 순으로 처리하면 막힘이 줄어듭니다.", -1))
          ])
        ]),
        _createElementVNode("section", _hoisted_41, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sui-card__head" }, [
            _createElementVNode("h2", { class: "sui-card__title" }, "검수 순서")
          ], -1)),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("ol", _hoisted_43, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
                return _createElementVNode("li", {
                  key: step.title
                }, [
                  _createElementVNode("strong", null, _toDisplayString(step.title), 1),
                  _createElementVNode("p", null, _toDisplayString(step.desc), 1)
                ])
              }), 64))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})